import { config } from '~app/config';

import { logger } from '~entities/logger';

import * as amplitude from '@amplitude/analytics-browser';

import type { AmplitudeAnalytics, AmplitudeEvent } from '../types';

amplitude.init(config.amplitudeKey, {
  defaultTracking: false,
  appVersion: config.version,
});

export const analytics: AmplitudeAnalytics = {
  track: ({ event, properties }: AmplitudeEvent) => {
    logger({ name: 'analytics-events', defaults: { remote: true } }).info({
      message: event.replace(/_/g, ' '),
      event,
      properties,
    });
    amplitude.track(event, properties);
  },

  setUserId: (id: string) => amplitude.setUserId(id),
};
